import {
  LayoutGridIcon,
  CarFrontIcon,
  CarIcon,
  CrownIcon,
  TruckIcon,
  BusIcon,
  ZapIcon,
  CalendarIcon,
  CalendarDaysIcon,
  PackageIcon,
  MapPinIcon,
  LifeBuoyIcon,
  BuildingIcon,
} from 'lucide-react'
import { CategoryIconName, BenefitIconName } from '../../data/easylease'
/** Hairline fleet marks shared by the ribbon, browse tiles and backdrop. */
export const CATEGORY_ICONS: Record<CategoryIconName, React.ElementType> = {
  all: LayoutGridIcon,
  sedan: CarFrontIcon,
  suv: CarIcon,
  luxury: CrownIcon,
  van: PackageIcon,
  pickup: TruckIcon,
  bus: BusIcon,
  electric: ZapIcon,
  monthly: CalendarIcon,
  daily: CalendarDaysIcon,
}
export const BENEFIT_ICONS: Record<BenefitIconName, React.ElementType> = {
  calendar: CalendarIcon,
  delivery: TruckIcon,
  support: LifeBuoyIcon,
  coverage: MapPinIcon,
  corporate: BuildingIcon,
}
